import { Component, useEffect, useState } from 'react';
import Consts from "Interfaces/Consts";

import ReactPaginate from "react-paginate";
import "GeneralComponents/CSS/_Pagination.css";
const mediaType = window.matchMedia("(min-width: 1024px)");

type Props = {
    itemsPerPage: number;
    itemsCount: number;
    callbackFromPager: (pageStart: number, pageEnd: number) => void;
    componentId: string;
    renewPageNumber: boolean;
}

const Pagination: React.FC<Props> = (props) =>  {

    const [itemOffset, setItemOffset] = useState(1);
    const [currentPage, setCurrentPage] = useState(0);

    const dir = getComputedStyle(document.documentElement).direction;
    const chevronDirectionLeft = `fa-chevron-${dir == 'rtl' ? 'left' : 'right'}`;
    const chevronDirectionRight = `fa-chevron-${dir == 'rtl' ? 'right' : 'left'}`;
    const pageCount = Math.ceil(props.itemsCount / props.itemsPerPage);


    useEffect(() => { updateAriaLabels(); }, [itemOffset, currentPage]);

    const updateAriaLabels = () => {

        document.querySelectorAll(".page-link").forEach(page => {
            const translatePage = page;
            const attr = translatePage.getAttribute("aria-label");
            let newAttr = attr.replace("Page", Consts.page);


            if (translatePage.getAttribute("aria-current")) {
                newAttr = attr.replace("Page", Consts.page).replace("is your current page", Consts.currentPage);
            }

            translatePage.setAttribute("aria-label", newAttr);
        });

    }

    const handlePageClick = (selectedItem: {selected: number}) => {

        const newOffset = (selectedItem.selected * props.itemsPerPage) % props.itemsCount;
        const startIndex = newOffset > 0 ? newOffset : 0;
        const endIndex = startIndex + props.itemsPerPage;
        const searchInput = document.getElementById("componentSearchBox-" + props.componentId);   
      
        setItemOffset(newOffset);
        setCurrentPage(selectedItem.selected);

        props.callbackFromPager(startIndex, endIndex);

        if (searchInput) { searchInput.focus(); }
    }

            
    return (

        <ReactPaginate
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination justify-content-center mb-0"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
            breakLabel="..."
            nextLabel={<i className={`fa fa-fw ${chevronDirectionLeft} `} aria-hidden="true"></i>}
            onPageChange={handlePageClick}
            pageRangeDisplayed={mediaType.matches ? 5 : 1}
            pageCount={pageCount}
            previousLabel={<i className={`fa fa-fw ${chevronDirectionRight} `} aria-hidden="true"></i>}
            renderOnZeroPageCount={null}
            forcePage={props.renewPageNumber ? 0 : currentPage}
            nextAriaLabel={Consts.nextSlideMessage}
            previousAriaLabel={Consts.prevSlideMessage}
            breakAriaLabels={{ forward: Consts.jumpForward, backward: Consts.jumpBackward }}
                   
        />


    );

}

export default Pagination;
